/* DANNICO · site-wide behaviour
   - [data-dn-quick-add] forms add to cart and render Honey's cart drawer (falls back to a normal submit).
   - .dn-seg option pills set the hidden variant id in their form.
*/
(() => {
  document.addEventListener('click', (e) => {
    const opt = e.target.closest('.dn-seg__opt');
    if (!opt || opt.disabled) return;
    const seg = opt.closest('.dn-seg');
    seg.querySelectorAll('.dn-seg__opt').forEach((o) => o.setAttribute('aria-checked', o === opt ? 'true' : 'false'));
    const input = opt.closest('form')?.querySelector('[data-dn-variant-input]');
    if (input) input.value = opt.dataset.variant;
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-dn-quick-add]');
    if (!form) return;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function' || !window.routes) return; // normal submit → cart page
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    const data = new FormData(form);
    data.append('sections', cart.getSectionsToRender().map((s) => s.id));
    data.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: data,
      });
      const json = await res.json();
      if (json.status) { form.submit(); return; }
      cart.renderContents(json);
      if (btn) btn.textContent = 'Added';
      setTimeout(() => { if (btn) btn.textContent = label; }, 2400);
    } catch (err) {
      form.submit();
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  });

  // Deferred media (performance): markup carries data-dn-src / data-dn-srcset / data-dn-poster.
  const fill = (el) => {
    if (el.dataset.dnSrcset) { el.srcset = el.dataset.dnSrcset; el.removeAttribute('data-dn-srcset'); }
    if (el.dataset.dnSrc) { el.src = el.dataset.dnSrc; el.removeAttribute('data-dn-src'); }
    if (el.dataset.dnPoster) { el.poster = el.dataset.dnPoster; el.removeAttribute('data-dn-poster'); }
  };
  const idle = (f) => (window.requestIdleCallback || ((cb) => setTimeout(cb, 200)))(f);
  const afterLoad = (f) => (document.readyState === 'complete' ? f() : window.addEventListener('load', f, { once: true }));

  // Card hover photos: only devices that can hover ever show them, so phones never download them.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointerover', (e) => {
      const alt = e.target.closest?.('.dn-card')?.querySelector('.dn-card__alt[data-dn-srcset], .dn-card__alt[data-dn-src]');
      if (alt) fill(alt);
    });
    afterLoad(() => idle(() => document.querySelectorAll('.dn-card__alt[data-dn-srcset], .dn-card__alt[data-dn-src]').forEach(fill)));
  }

  // Videos row: covers attach as the row nears the screen (whole row at once, so swiping sideways never shows
  // a blank tile). Chrome only draws a poster added after the element was created once load() runs; with
  // preload="none" that fetches the video's metadata only.
  // Then each video plays muted while most of it is on screen and pauses when it leaves — unless the visitor
  // asked their device for reduced motion or data saver, or paused that video themselves.
  const rows = document.querySelectorAll('.dn-videos__row');
  const fillRow = (row) => row.querySelectorAll('video[data-dn-poster]').forEach((v) => { fill(v); v.load(); });
  const noAutoplay = window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData === true;
  if (rows.length) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => {
        if (en.isIntersecting) { fillRow(en.target); io.unobserve(en.target); }
      }), { rootMargin: '800px 0px' });
      rows.forEach((r) => io.observe(r));

      if (!noAutoplay) {
        const auto = new IntersectionObserver((entries) => entries.forEach((en) => {
          const v = en.target;
          if (en.isIntersecting) {
            if (v.dataset.dnUserPaused || !v.paused) return;
            fillRow(v.closest('.dn-videos__row')); // in case the cover observer hasn't run yet
            v.muted = true; v.playsInline = true;
            v.play().catch(() => {}); // e.g. iPhone Low Power Mode blocks autoplay: the cover stays
          } else if (!v.paused) {
            v.dataset.dnAutoPausing = '1';
            v.pause();
          }
        }), { threshold: 0.6 });
        rows.forEach((r) => r.querySelectorAll('video').forEach((v) => {
          // a pause the visitor made (not ours) means: leave this video alone from now on
          v.addEventListener('pause', () => {
            if (v.dataset.dnAutoPausing) delete v.dataset.dnAutoPausing;
            else if (!v.ended) v.dataset.dnUserPaused = '1';
          });
          auto.observe(v);
        }));
      }
    } else rows.forEach(fillRow);
  }
})();
